import { useMutation } from "@apollo/client"
import { ROUND_START } from "../queries/roundStart"

interface RoundStartInput {
  tournamentId: number
  addNew?: boolean
  earlyClose?: boolean
}

export const useRoundStart = () => {
  const [startRound, { loading, error }] = useMutation(ROUND_START)

  const roundStart = async (input: RoundStartInput) => {
    try {
      const { data } = await startRound({
        variables: {
          RoundStartInput: input,
        },
      })
      return data?.RoundStart
    } catch (err) {
      console.error("Error starting round:", err)
      throw err
    }
  }

  return {
    roundStart,
    loading,
    error,
  }
}
